/** Dialog for editing some VJT properties. */

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, Input, InputLabel } from "@material-ui/core";
import React, { ChangeEvent, useEffect, useState } from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { Cancel, Save } from "@material-ui/icons";
import { objectToFormData } from "../../../../web-services/utils/object-to-form-data";
import { IFelhasznalokezeloCreateProps } from "./props";

import "./felhasznalokezelo-create-dialog.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function FelhasznalokezeloCreateDialog(props: IFelhasznalokezeloCreateProps)
{
    const [errorMsg, setErrorMsg] = useState<string | undefined>();
    const [errorCategoryMsg, setErrorCategoryMessage] = useState<string | undefined>();
    const [isRequestSending, setIsRequestSending] = useState<boolean | undefined>();

    const [username, setUsername] = useState<string>('');
    const [teljesnev, setTeljesnev] = useState<string>('');
    const [jelszo, setJelszo] = useState<string>('');

 
    useEffect(() =>
    {
        if (!isRequestSending) return;

        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            try
            {

                await props.httpClient.post(
                    "user/registrate",
                    "",
                    objectToFormData({
                        username: username,
                        name: teljesnev,
                        password: jelszo,

                    }),
                    15000
                );
                setIsRequestSending(false);
                props.onSaveSuccess();
            }
            catch (err: any)
            {
                setIsRequestSending(false);
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorMsg("Kérjük, próbálja újra a mentést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
        };

        fetchData().catch(console.error);
    }, [isRequestSending]);

    const renderAlert = (errorText: string | undefined, errorCategoryText: string | undefined) => (
        errorText
            ? (
                <Grid item xs={12}>
                    <Alert severity="error" className="vjt-edit-error">{errorCategoryText
                        ? <AlertTitle>{errorCategoryText}</AlertTitle> : undefined}{errorText}
                    </Alert>
                </Grid>
            )
            : undefined
    );

    const renderCircularProgress = () => (
        isRequestSending
            ? <Grid item xs={12}><div className="circular-progress-container"><CircularProgress size={24} /></div></Grid>
            : undefined
    );

    const renderDialogActions = () =>
    {
        let buttons = [
            <Button
                key={0}
                startIcon={<Cancel />}
                variant="contained"
                color="secondary"
                onClick={props.onClose}
            >
                Mégsem
            </Button>
        ];
        buttons.push(
            <Button
                key={1}
                startIcon={<Save />}
                variant="contained"
                disabled={isRequestSending}
                color="primary"
                onClick={() => setIsRequestSending(true)}
                autoFocus
            >
                Mentés
            </Button>
        );

        return buttons;
    };


    const renderMegnevezesAndPortalIp = () =>
    {
        let fields = [];

        fields.push(
            <Grid item xs={12} key={1}>
                <FormControl variant="standard" className="wide-field">
                    <InputLabel>Felhasználónév</InputLabel>
                    <Input
                        value={username}
                        onChange={(event: ChangeEvent<{
                            name?: string | undefined;
                            value: unknown;
                        }>) => setUsername(event.target.value as string)} required
                    />
                </FormControl>
            </Grid>
        );
        fields.push(
            <Grid item xs={12} key={2}>
                <FormControl variant="standard" className="wide-field">
                    <InputLabel>Jelszó</InputLabel>
                    <Input
                        type="password"
                        value={jelszo} onChange={e => setJelszo(e.target.value)} required
                    />
                </FormControl>
            </Grid>
        );

        fields.push(
            <Grid item xs={12} key={3}>
                <FormControl variant="standard" className="wide-field">
                    <InputLabel>Név</InputLabel>
                    <Input
                        value={teljesnev} onChange={(event: ChangeEvent<{
                            name?: string | undefined;
                            value: unknown;
                        }>) => setTeljesnev(event.target.value as string)} required
                    />
                </FormControl>
            </Grid>
        );

        return fields;
    };


    return (
        <Dialog open={props.open || false}>
            <DialogTitle>Felhasználó létrehozás</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    {renderMegnevezesAndPortalIp()}
                    {renderCircularProgress()}
                    {renderAlert(errorMsg, errorCategoryMsg)}
                </Grid>
            </DialogContent>
            <DialogActions>
                {renderDialogActions()}
            </DialogActions>
        </Dialog>
    );
}
